import english from '../translations/en-UK.json';
import greek from '../translations/el-GR.json';
import turkish from '../translations/tr-CY.json';

export { english, greek, turkish };
